module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_realtime_call_count-f1d72008c6b2c79113431d2c72588b4d.png";